export default function pageNavigation(activeSection: string) {
  return {
    opened: false,
    activeSection,
    activeIndex: 0,
    sections: [] as HTMLElement[],
    toggleOpen() {
      this.opened = !this.opened;
    },
    closeDialog() {
      this.opened = false;
    },
    goToSection(slug: string, index: number) {
      if (index < this.activeIndex) {
        document.getElementById('wrapper')?.classList.add('scrolled-up');
      } else {
        document.getElementById('wrapper')?.classList.remove('scrolled-up');
      }
      this.activeIndex = index;
      this.activeSection = slug;
      window.location.hash = slug;
      const currentSection = document.getElementById('current-section');
      const activeSectionLink = document.getElementById(`${slug}-item`)?.innerHTML;
      if (currentSection && activeSectionLink) {
        currentSection.innerHTML = activeSectionLink;
      }
    },
    init() {
      this.sections = Array.from(document.querySelectorAll('.customer-service-section')) as HTMLElement[];

      const onScroll = () => {
        const windowHeight = window.innerHeight;

        // Use array find method to find the section in view
        const sectionInView = this.sections.find((section) => {
          const rect = section.getBoundingClientRect();
          const { top } = rect;
          // If section is in the upper half of the viewport
          return top > 0 && top <= windowHeight / 2;
        });

        // Update the currentSection to the slug of the section found
        if (sectionInView && sectionInView.dataset.slug) {
          const { slug } = sectionInView.dataset;
          if (slug != null) {
            this.activeSection = slug;
            window.history.pushState({}, '', `#${slug}`);
            const currentSection = document.getElementById('current-section');
            const activeSectionLink = document.getElementById(`${slug}-item`)?.innerHTML;
            if (currentSection && activeSectionLink) {
              currentSection.innerHTML = activeSectionLink;
            }
          }
        }
      };
      window.addEventListener('scroll', onScroll);
    },
  };
}
